var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarMetricsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4999 0.872073C16.8844 0.872073 17.2319 1.10121 17.3833 1.45462L20.6337 9.03874L24.6666 9.03874C25.1974 9.03874 25.6277 9.46907 25.6277 9.9999C25.6277 10.5307 25.1974 10.9611 24.6666 10.9611L19.9999 10.9611C19.6154 10.9611 19.2679 10.7319 19.1164 10.3785L16.4999 4.27324L10.3833 18.5452C10.2319 18.8986 9.88439 19.1277 9.4999 19.1277C9.1154 19.1277 8.76791 18.8986 8.61645 18.5452L5.36611 10.9611L1.33323 10.9611C0.802396 10.9611 0.372069 10.5307 0.372069 9.9999C0.372069 9.46907 0.802396 9.03874 1.33323 9.03874L5.9999 9.03874C6.38439 9.03874 6.73189 9.26788 6.88335 9.62128L9.4999 15.7266L15.6164 1.45462C15.7679 1.10121 16.1154 0.872073 16.4999 0.872073Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMetricsIcon);
export default __webpack_public_path__ + "static/media/navbar-metrics-icon.fd30c2263b2e2f46a20d5b84b6265e5a.svg";
export { ForwardRef as ReactComponent };